<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Profile</h2>
		</div>

		<v-container>
			<v-form ref="form" v-model="valid" @submit.prevent="editProfile">
				<v-row class="d-flex flex-column justify-center align-center mb-6">
					<v-badge :value="hover" icon="mdi-camera" avatar bottom bordered overlap offset-x="40" offset-y="40">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-hover v-model="hover">
									<v-avatar v-on="on" v-bind="attrs" size="150" class="mb-4" style="cursor: pointer;" @click="openFileDialog()">
										<v-img sizes="150" v-if="!imgError" :src="profilePicture" @error="imgError = !imgError"></v-img>
										<v-icon v-else size="150">mdi-account-circle</v-icon>
									</v-avatar>
								</v-hover>
							</template>
							<span>It’s recommended to use image with resolution approximately 200 x 200 pixels and recommended size is under 500KB</span>
						</v-tooltip>
					</v-badge>
					<span class="text-h4">{{fullName}}</span>
					<span class="text-h6">{{entity.title}}</span>
					<span style="max-width: 60%; text-align: center;">{{entity.bio}}</span>

					<input type="file" ref="attachment" accept="image/png, image/jpeg, image/jpg" style="display: none;" @change="showImage" required />
				</v-row>

				<v-row class="d-flex justify-center align-center">
					<v-col cols="12" sm="6">
						<v-alert v-model="alert.show" :type="alert.type" dismissible>{{alert.message}}</v-alert>
						<v-text-field v-model="entity.firstName" label="First Name" :rules="[(v) => !!v || 'First Name is required']" dense rounded filled required></v-text-field>
						<v-text-field v-model="entity.lastName" label="Last Name" :rules="[(v) => !!v || 'Last Name is required']" dense rounded filled required></v-text-field>
						<v-text-field v-model="entity.title" label="Title" :rules="[(v) => !!v || 'Title is required']" dense rounded filled required></v-text-field>
						<v-textarea v-model="entity.bio" label="Bio" :rules="[(v) => !!v || 'Bio is required']" dense filled rounded no-resize></v-textarea>
					</v-col>
				</v-row>
				<v-row class="d-flex justify-center align-center">
					<v-btn :disabled="!valid" class="px-8" type="submit" color="primary" rounded>Save Changes</v-btn>
				</v-row>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return {
			hover: false,
			valid: true,
			entity: {},
			attachment: null,
			imgError: false,
			alert: { show: false, message: "" },
			baseLocation: axios.defaults.baseURL
		};
	},
	computed: {
		fullName() {
			return this.entity.firstName + " " + this.entity.lastName;
		},
		profilePicture() {
			return this.attachment ? this.entity.image : this.baseLocation + "/asset/file/user/" + this.$store.state.principal.image;
		}
	},
	mounted() {
		this.getTenantStaff();
	},
	methods: {
		openFileDialog() {
			this.$refs.attachment.click();
		},
		showImage(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					this.entity.image = fr.result;
					this.attachment = files[0]; // this is an image file that can be sent to server...
					this.imgError = false;
				});
			} else {
				this.attachment = null;
			}
		},
		getTenantStaff() {
			axios.get("/system/staff?tenantId=" + this.$store.state.principal.tenantId + "&id=" + this.$store.state.principal.id).then(response => {
				this.entity = response.data;
				this.entity.image = this.$store.state.principal.image;
			});
		},
		editProfile() {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}

			axios
				.post("/system/staff/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(response => {
					this.$store.commit("updatePrincipal", response.data);
					this.alert.show = true;
					this.alert.type = "success";
					this.alert.message = "Profile updated successfully";
					this.$refs.form.resetValidation();
				})
				.catch(() => {
					this.alert.show = true;
					this.alert.type = "error";
					this.alert.message = "Profile update failed";
				});
		}
	}
};
</script>